import { render, staticRenderFns } from "./BaseButtonBulk.vue?vue&type=template&id=19491a01&scoped=true"
import script from "./BaseButtonBulk.vue?vue&type=script&lang=ts"
export * from "./BaseButtonBulk.vue?vue&type=script&lang=ts"
import style0 from "./BaseButtonBulk.vue?vue&type=style&index=0&id=19491a01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19491a01",
  null
  
)

export default component.exports